import React, { useContext, useState } from "react";
import dayjs from "dayjs";
import { Dialog, DialogTitle, DialogContent, Tabs, Tab } from "@mui/material";
import AuthContext from "../../context/AuthContext/AuthContext";
import { useCustomTranslation } from "../../hooks/useCustomTranslation";
import CreatePromise from "./CreatePromise";

import OrganizationMode from "./components/OrganizationMode";
import CampaignMode from "./components/CampaignMode";
import PromiseReminderHistory from "./components/PromiseReminderHistory";

export const PromisesList = () => {
  const { t } = useCustomTranslation("Promises List");
  const authContext = useContext(AuthContext);
  const tokenOrganizationId = authContext?.authContext?.accessToken?.organization_id;
  const orgId = tokenOrganizationId || localStorage.getItem("selectedOrganisationId") || "";

  const [openCreate, setOpenCreate] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [viewMode, setViewMode] = useState(0);

  const [period, setPeriod] = useState({
    selectedPeriod: "today",
    start_date: dayjs(new Date()),
    end_date: dayjs(new Date()),
    start_time: dayjs().startOf("day").format("HH:mm"),
    end_time: dayjs().endOf("day").format("HH:mm"),
  });

  // null => organization mode; otherwise { id, name } => campaign mode
  const [selectedCampaign, setSelectedCampaign] = useState(null);

  const handleCloseCreate = () => {
    setOpenCreate(false);
    setTimeout(() => setRefreshKey((k) => k + 1), 600);
  };

  return (
    <div className="flex flex-col gap-y-4">
      <Dialog open={openCreate} onClose={handleCloseCreate} maxWidth="lg" fullWidth>
        <DialogTitle>{t("add_promise_button")}</DialogTitle>
        <DialogContent>
          <CreatePromise onClose={handleCloseCreate} defaultCampaign={selectedCampaign} />
        </DialogContent>
      </Dialog>

      <Tabs
        value={viewMode}
        onChange={(_, value) => {
          setViewMode(value);
          if (value === 1) setSelectedCampaign(null);
        }}
      >
        <Tab label={t("promises", "Promises")} />
        <Tab label={t("promise_reminder_history", "Reminder History")} />
      </Tabs>

      {viewMode === 0 ? (
        !selectedCampaign ? (
          <OrganizationMode
            organizationId={orgId}
            period={period}
            setPeriod={setPeriod}
            onSelectCampaign={(c) => setSelectedCampaign(c)}
            onAddPromise={() => setOpenCreate(true)}
            refreshKey={refreshKey}
          />
        ) : (
          <CampaignMode
            organizationId={orgId}
            campaign={selectedCampaign}
            period={period}
            setPeriod={setPeriod}
            onBack={() => setSelectedCampaign(null)}
            onAddPromise={() => setOpenCreate(true)}
            refreshKey={refreshKey}
          />
        )
      ) : (
        <PromiseReminderHistory
          organizationId={orgId}
          refreshKey={refreshKey}
        />
      )}

      {/* floating add if you want it globally */}
      {/* <div className="flex justify-end">
        <Button variant="contained" onClick={() => setOpenCreate(true)}>
          {t("add_promise_button")}
        </Button>
      </div> */}
    </div>
  );
};
